import { ref, watchEffect } from 'vue'

const MODE_KEY = 'theme-mode'

function readStored(key, fallback) {
	return window.localStorage.getItem(key) || fallback
}

const mode = ref(readStored(MODE_KEY, 'dark'))

watchEffect(() => {
	document.documentElement.dataset.mode = mode.value
	window.localStorage.setItem(MODE_KEY, mode.value)
})

export function useTheme() {
	function toggleMode() {
		mode.value = mode.value === 'dark' ? 'light' : 'dark'
	}

	return { mode, toggleMode }
}
